import { use, useContext, useEffect, useState } from "react";
import { HorizontalLayout, VerticalLayout, VerticalPageLayout } from "../layout";
import { TitleAtom } from "../../atoms/titleAtom";
import { Chip, ChipFilter } from "../../molecule/Chip";
import { IconButton, StandardButton } from "../../atoms/buttons";
import { icon } from "../../functions/icons";
import { StandardComp } from "../../atoms/standardComp";
import { TextAtom } from "../../atoms/TextAtom";
import { ProgressBarComplete } from "../../molecule/timeBar";
import { TitleDescriptionText } from "../../atoms/titleDescription";
import { PageContext, ToastContext } from "../../App";
import { LABELS, STATUS, STEP_LABELS } from "../../constants/statusLabels";
import { AddTask, UpdateTask } from "../taskModal";
import { getAPI, postAPI, updateAPI } from "../../api/api";
import { Spinner } from "../../atoms/spinner";
import { borderStyle, borderWidth } from "polished";
import { InputForm, TextAreaForm } from "../../atoms/input";

export const TasksPage = ({ setSelectedPage }) => {
    const [selectedFilterOption, setSelectedFilterOption] = useState(1);
    const [templateStepsOptions, setTemplateStepsOptions] = useState([]);
    const [selectedTemplateStep, setSelectedTemplateStep] = useState(null);
    const toastContext = useContext(ToastContext);
    const [allTasks, setAllTasks] = useState([]);
    const [tasks, setTasks] = useState([]);
    const [loading, setLoading] = useState(false);
    const [isLoading, setIsloading] = useState(false);

    const [taskModalActive, setTaskModalActive] = useState(false);
    const loadTemplateSteps = async () => {
        setLoading(true);
        const query = `api/tasks/template/steps`
        const res = await getAPI(query);
        
        if (res.status === "ok") {
            setTemplateStepsOptions(res.data);
        }
        setLoading(false);
    }
    const handleTemplateStepClick = () => {
        setSelectedPage(2);
    }
    const loadTasks = async () => {
        setLoading(true);
        const query = `api/tasks`;
        const res = await getAPI(query);
        console.log("Tasks:", res);
        if (res.status === "ok") {
            setAllTasks(res.data);
            setTasks(res.data);
        }
        setLoading(false);
    }
    const loadActiveTasks = async () => {
        setLoading(true);
        const query = `api/tasks/active`;
        const res = await updateAPI(query);
        console.log("Active Tasks:", res);
        if (res.status === "ok") {
            setAllTasks(res.data);
            setTasks(res.data);
        }
        setLoading(false);
    }
    const handleCardClickFilter = (step) => {
        if (!step) {
            setSelectedTemplateStep(null);
            setTasks(allTasks);
            return;
        }

        setSelectedTemplateStep({
            id: step.id_template_step,
            actions: step.actions || [],
        });

        if (!step.actions || step.actions.length === 0) {
            setTasks(allTasks);
            return;
        }

        const filtered = allTasks.filter(t =>
            step.actions.includes(t.id_action)
        );
        setTasks(filtered);
    };


    const reloadTasks = async () => {
        const query = `api/tasks/reload`;
        setIsloading(true);
        console.log("Reloading tasks...");
        const res = await postAPI(query);
        console.log("Reload Tasks:", res);
        toastContext.showToast("Taken opnieuw geladen", "success");
        if (res.status === "ok") {
            await loadTemplateSteps()
            await loadTasks();
        }
        setIsloading(false);
    }


    useEffect(() => {
        loadTemplateSteps();
        // loadTasks();
        loadActiveTasks();
    }, []);

    const filterOptions = [
        { id: 1, label: "Alles" },
        { id: 2, label: "Vandaag" },
        { id: 3, label: "Deze week" },
        { id: 4, label: "Volgende week" }
    ];
    useEffect(() => {
        const filtered = filterTasks(allTasks, selectedFilterOption);
        setTasks(filtered);
        console.log(filtered, "Filtered Tasks")
    }, [selectedFilterOption, allTasks]);
    const filteredTasks = filterTasks(tasks, selectedFilterOption);

    if (loading) { return <VerticalPageLayout className={"center"}><Spinner /></VerticalPageLayout> }
    return (
        <>
            <VerticalLayout className="standard-padding no-padding-top" style={{ width: "auto", }}>
                {templateStepsOptions.length > 0 && !loading ? <TemplateSteps onCardClick={handleCardClickFilter} onIconClick={handleTemplateStepClick} tasks={templateStepsOptions} /> : <FallBackTemplateSteps />}
               
                <HorizontalLayout className="phone-step-task-title standard-margin-top">
                    <VerticalLayout style={{ gap: "1rem" }}>
                        <TitleAtom className={"task-title-action"} title={"Taken"} />
                        <ChipFilter options={filterOptions} selected={selectedFilterOption} onSelect={setSelectedFilterOption} />
                    </VerticalLayout>
                    <StandardButton onClick={() => setTaskModalActive(!taskModalActive)} className={"add-task"} style={{ gap: ".5rem" }}>
                        {icon("plus", 24, "var(--white)")}
                        Taak toevoegen
                    </StandardButton>
                    <StandardButton onClick={() => reloadTasks()} className={"add-task"} style={{ gap: ".5rem" }}>
                        <div className={`${isLoading && "rotating"}`}>{icon("retry", 24, "var(--white)")}</div>

                    </StandardButton>
                </HorizontalLayout>
                <TaskComp tasks={filteredTasks} load={loadActiveTasks} />
            </VerticalLayout>
            <AddTask selectedTemplateStep={selectedTemplateStep} visible={taskModalActive} dismiss={() => setTaskModalActive(false)} loadTasks={() => loadActiveTasks()} />
        </>
    )
}

const FallBackTemplateSteps = () => {

    return (
        <TextAtom title={"Er zijn op dit moment geen template stappen beschikbaar."} />
    )
}

const TaskComp = ({ tasks, load }) => {

    return (
        <VerticalLayout className="standard-margin-top task-container" style={{ gap: "1rem" }}>
            {tasks.map((task) => (
                <TaskCard key={task.id_task} task={task} load={load} />
            ))}
        </VerticalLayout>
    )
}

const TaskCard = ({ task, load }) => {
    const navigationContext = useContext(PageContext);
    const toastContext = useContext(ToastContext);
    const [updateTask, setUpdateTask] = useState(false);
    const actions = [{
        id: 1,
        label: "Afronden",
        color: "success-600",
        icon: "check",
        backgroundColor: "success-200",
    },
    {
        id: 2,
        label: "Bewerken",
        color: "grey-800",
        icon: "edit",
        backgroundColor: "grey-200",
    },
    {
        id: 3,
        label: "Weigeren",
        icon: "trash",
        color: "error-600",
        backgroundColor: "error-200",
    }];
    const HandleTaskClick = () => {
        if (task.task_connection === "no-connection") return
        if (task.id_lead) {
            navigationContext.handleNavigation({ ...navigationContext.sidebar, navigation: 19, back_page: 17, id_lead: task.id_lead, id_lead_company: null });
        } else {
            navigationContext.handleNavigation({ ...navigationContext.sidebar, navigation: 19, back_page: 17, id_lead: null, id_lead_company: task.id_lead_company });
        }
    }
    const isMobile = window.innerWidth <= 768;

    const updateTaskStatus = async (id_task, task_status) => {
        const query = `api/tasks/status/update`;
        const body = { tasks: [{ id_task, task_status }] };
        const res = await updateAPI(query, body);
        if (res.status === "ok") {
            load()
            task_status === 6 ? toastContext.showToast(<>Taak "{task.title}" succesvol afgerond</>, "success", 3000) : toastContext.showToast(<>Taak "{task.title}" succesvol weggehaald</>, "success", 3000)
        }
    }
    const handleActionButton = (id) => {
        switch (id) {
            case 1:
                updateTaskStatus(task.id_task, 6);
                break;

            case 2:
                setUpdateTask(true);
                break;

            case 3:
                updateTaskStatus(task.id_task, 3);
                break;
            default:
                console.warn("Unknown action:", id);
        }
    };
    return (
        <>
            <UpdateTask visible={updateTask} dismiss={() => setUpdateTask(false)} task={task} loadTasks={load} />
            <StandardComp onClick={HandleTaskClick} editClass={`no-margin-right task-card ${task.task_connection === "no-connection" ? "no-hover" : ""}`}>
                <VerticalLayout style={{ gap: "1rem" }}>
                    <DateInformation task={task} />
                    <HorizontalLayout className="space-between" style={{ width: "auto", }}>
                        <VerticalLayout style={{ width: "auto" }}>
                            <TitleAtom className={"task-title"} title={task.title} />
                            <TextAtom className={"task-description progress-description"} title={task.description} />
                        </VerticalLayout>

                    </HorizontalLayout>

                    {task.action === 1 && (
                        <HorizontalLayout style={{ gap: "1rem" }}>
                            <Notes initial={task.note} id_note={task.id_note} id_task={task.id_task} />
                            <HorizontalLayout className="task-actions-group">
                                {actions.map((action) => (
                                    <StandardButton onClick={(e) => { e.stopPropagation(); handleActionButton(action.id) }} backgroundColor={action.backgroundColor} textColor={action.color} className={"no-margin action-buttons"} key={action.id}>
                                        {isMobile ? icon(action.icon, 16, `var(--${action.color})`) : action.label}
                                    </StandardButton>
                                ))}
                            </HorizontalLayout>
                        </HorizontalLayout>
                    )}
                </VerticalLayout>
            </StandardComp>
        </>

    )

}
const Notes = ({ initial = "", id_note, id_task }) => {
    const [note, setNote] = useState(initial);
    const [edit, setEdit] = useState(false);
    const toast = useContext(ToastContext)
    const handleClick = async (e) => {
        e.stopPropagation();
        if (!edit) return
        await handleSave();
    }
    const handleSave = async () => {
        const query = "api/tasks/update/note";
        const body = { note, id_task, id_note };
        await updateAPI(query, body);
        setEdit(false);
        toast.showToast("Notitie opgeslagen", "success", 3000);

    }
    const handleKeyDown = async (e) => {
        if (e.key === "Enter") {
            e.stopPropagation();
            e.preventDefault();
            await handleSave();
        }
    };
    useEffect(() => {
        if (note !== initial) {
            setEdit(true);
        }
    }, [note, initial]);
    return (
        <HorizontalLayout className="task-notes" style={{ gap: "0.5rem", position: "relative", width: "100%", alignItems: "center" }}>
            <TextAreaForm
                readOnly={false}
                expand={false}
                style={{ width: "100%", marginBottom: "0", minHeight: "unset" }}
                value={note}
                typeInput={(v) => setNote(v)}
                onKeyDown={handleKeyDown}
            />
            <IconButton icon2={edit ? "check" : "note"} onClick={(e) => handleClick(e)} />
        </HorizontalLayout>
    );
};
const TemplateSteps = ({ tasks, onIconClick, onCardClick }) => {
    const isMobile = window.innerWidth <= 768;
    const [collapsed, setCollapsed] = useState(true);
    const [selectedStepId, setSelectedStepId] = useState(null);
    const handleCollapse = () => {
        if (!isMobile) return;
        setCollapsed(!collapsed);
    };
    const handleCardClick = (task) => {
        const newSelected = selectedStepId === task.id_template_step ? null : task.id_template_step; // toggle
        setSelectedStepId(newSelected);
        if (newSelected) {
            onCardClick(task);
        } else {
            onCardClick(null);
        }
    };
    return (
        <>
            {isMobile && (
                <HorizontalLayout className="card-background-color space-between" onClick={() => handleCollapse()} style={{ cursor: "pointer", padding: ".5rem", width: "auto", marginBottom: ".5rem", borderRadius: "calc(.5rem * var(--br-scale))", border: `1px solid var(--border-color)` }}>
                    <TextAtom className={"task-title-action"} style={{ width: "unset", }} title={"Template stappen"} />
                    <IconButton onClick={() => handleCollapse()} icon2={collapsed ? "chevron-down" : "chevron-up"} size={24} />
                </HorizontalLayout>
            )}
            <HorizontalLayout className={`${isMobile && collapsed ? "collapsed" : "not-collapsed"} phone-step-task-container`} style={{ gap: "1rem", overflowX: "auto", maxWidth: "calc(100vw - 7rem)", minHeight: "12rem", height: "auto" }}>
                {tasks.map((task) => (
                    <StepCard key={task.id_template_step} task={task} onIconClick={onIconClick} onCardClick={() => handleCardClick(task)} selected={selectedStepId === task.id_template_step} />
                ))}
            </HorizontalLayout>
        </>

    )
}
const StepCard = ({ task, onIconClick, onCardClick, selected }) => {
    
    return (
        <StandardComp
            onClick={onCardClick}
            editClass={`no-margin step-card ${selected ? "selected" : ""}`}
            style={{ minHeight: "8rem", maxWidth: "15rem", minWidth: "15rem", height: "auto" }}
            content={
                <VerticalLayout style={{ gap: "0.5rem" }}>
                    <TitleDescAction title={task.step_title} description={task.requirements?.map(r => r.requirement_title).join(" • ") || "Geen vereisten"} icon2={"dots-vertical"} onIconClick={onIconClick} />
                    {(task.progress > 0) ? (
                        <VerticalLayout style={{ width: "unset" }}>
                            <span className="small-text standard-text-color-light">{(task.total_leads || task.finished_leads) ? `${task.finished_leads}/${task.total_leads}` : "Er zijn geen taken nog"}</span>
                            <ProgressBarComplete progress={`${task.progress}%`} />
                        </VerticalLayout>

                    ) : <div style={{ height: "0.5rem" }}></div>}
                    <TextAtom style={{ marginTop: "auto" }} className={"progress-description"} title={task.step_description} />
                    <Chip className="task-status" style={{ width: "max-content", textTransform: "capitalize", marginTop: "auto", }} label={STEP_LABELS[task.status]} variant={STATUS[task.status]} size="medium" />
                </VerticalLayout>
            } />
    )
}


const DateInformation = ({ task }) => {
    return (
        <HorizontalLayout className="date-information" style={{ gap: "auto", borderStyle: "solid", borderWidth: "0", borderBottomWidth: "1px", borderColor: "var(--border-color)", paddingBottom: ".5rem" }}>
            <HorizontalLayout style={{ gap: "0.25rem", alignItems: "center" }}>
                {(task.status < 6 && !task.time) && <DateInfo iconName={"calendar"} status={"Datum"} task={task} />}
                {(task.time && task.status < 6 ) && <DateInfo iconName={"clock"} status={"Ingeplande tijd "} task={task} />}
                {task.status == 6 && <DateInfo iconName={"check"} status={"Afgerond op"} task={task} />}

            </HorizontalLayout>
            <HorizontalLayout style={{ width: "unset", marginLeft: "auto", gap: "0.25rem", alignItems: "center" }}>
                <TextAtom className={"small-text grey-600"} title={`#${task.id_task}`} />
                <Chip className="task-status" style={{ width: "max-content", textTransform: "capitalize", marginTop: "auto", }} label={LABELS[task.status]} variant={STATUS[task.status]} size="medium" />
            </HorizontalLayout>
        </HorizontalLayout>
    )
}


const DateInfo = ({ iconName, status ,task }) => {
    return (
        <HorizontalLayout style={{ gap: "0.5rem", alignItems: "center" }}>
            {icon(iconName, 16, !task.time ? "var(--grey-600)": "var(--primary-600)")}
            <TextAtom className={`small-text ${!task.time ? "grey-600" : "primary-600 bold-text"}`}
                title={`${status}: ${task.date} ${task.time ? `om ${task.time}` : ""}`} />
        </HorizontalLayout>
    )
}


const TitleDescAction = ({ title, description, icon2, onIconClick, style }) => {
    return (
        <HorizontalLayout style={{ ...style, gap: "1rem" }} className="space-between">
            <TitleDescriptionText style={{ overflow: "hidden" }} className={"title-description-action"} title={title} description={description} />
            <IconButton onClick={onIconClick} icon2={icon2} size={24} />
        </HorizontalLayout>
    )
}

function filterTasks(tasks, filterId, actionId = null) {
    const today = new Date();
    const startOfWeek = new Date(today);
    startOfWeek.setDate(today.getDate() - today.getDay());
    const endOfWeek = new Date(startOfWeek);
    endOfWeek.setDate(startOfWeek.getDate() + 7);

    const startNextWeek = new Date(endOfWeek);
    const endNextWeek = new Date(startNextWeek);
    endNextWeek.setDate(startNextWeek.getDate() + 7);

    return tasks.filter(task => {
        const taskDate = new Date(task.date);
        let dateMatch = false;
        switch (filterId) {
            case 1:
                dateMatch = true;
                break;
            case 2:
                dateMatch = taskDate.toDateString() === today.toDateString();
                break;
            case 3:
                dateMatch = taskDate >= startOfWeek && taskDate < endOfWeek;
                break;
            case 4:
                dateMatch = taskDate >= startNextWeek && taskDate < endNextWeek;
                break;
            default:
                dateMatch = true;
        }
        const actionMatch = actionId ? task.id_action === actionId : true;

        return dateMatch && actionMatch;
    });
}
